import { camelizeKeys } from "humps";
import { merge, omit } from "ramda";
import { PARTNERS } from "app_constants";
import {
  checkStatus,
  getRequest,
  makeAuthHeaders,
  parseJSON,
  postRequest,
} from "helpers/requests";

export function getAllRoles(brandPrettyUrl: string): Promise<any> {
  return fetch(
    `${PARTNERS}/brands/${brandPrettyUrl}/roles.json`,
    getRequest(makeAuthHeaders())
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys);
}

export interface ICreateMerchantUserAttributes {
  // Require attributes
  email: string;
  firstName: string;
  lastName: string;
  roleId: string;

  // Optional attributes - but required to specify at least 1
  brands?: string[];
  locations?: string[];
}

export interface IMerchantUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  roleId?: string;
  roleName?: string;
}

export function postCreateMerchantUser(
  brandPrettyUrl: string,
  params: ICreateMerchantUserAttributes
): Promise<IMerchantUser> {
  return fetch(
    `${PARTNERS}/brands/${brandPrettyUrl}/merchant_users`,
    postRequest(params, makeAuthHeaders())
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((user) => merge(omit(["uuid"], user), { id: user.uuid }))
    .then((user) => camelizeKeys(user) as IMerchantUser);
}
